export default __webpack_public_path__ + "static/media/chukwu.3e2def65.png";